import { render, staticRenderFns } from "./HelpMainPage.vue?vue&type=template&id=bf9232cc&lang=pug"
import script from "./HelpMainPage.vue?vue&type=script&lang=js"
export * from "./HelpMainPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf9232cc')) {
      api.createRecord('bf9232cc', component.options)
    } else {
      api.reload('bf9232cc', component.options)
    }
    module.hot.accept("./HelpMainPage.vue?vue&type=template&id=bf9232cc&lang=pug", function () {
      api.rerender('bf9232cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/help_center/HelpMainPage.vue"
export default component.exports